module.exports = __webpack_public_path__ + "img/ac44d79.jpg";